import React from "react";
import WtfBenefitsLanding from "../../components/wtf-benefits/WtfBenefitsLanding";
import HelmetWrapper from "../../HelmetWrapper";

const WtfBenefits = () => {
  return (
    <HelmetWrapper title="WTF: Gym Benefits">
      <WtfBenefitsLanding />
    </HelmetWrapper>
  );
};

export default WtfBenefits
